<template>
    <div>
        <Navbar/>

        <b-container class="mt-4" style="height: 50vh">
            <b-row>
                <h4 v-if="state === states.Loading">Recovering your shopping cart</h4>
                <h4 v-else-if="state === states.Error">We had trouble recovering your cart. Please try again.</h4>
                <h4 v-else-if="state === states.Success">Redirecting to your cart...</h4>
            </b-row>

        </b-container>
        <Footer/>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import {mapState} from "vuex";

const states = {
    Loading: 0,
    Error: 1,
    Success: 2
}
export default {
    name: "RecoverCart",
    components: {Footer, Navbar},
    props: ['token'],
    computed: {
        ...mapState({
            publications: state => state.stateData.stateData.publications,
            isHomeschool: state => state.homeschool.homeschoolStore,
            selectedState: state => state.selectedState,
        }),
        isHomeschoolCart() {
            return this.cart.homeschool == "1";
        }
    },
    data: () => ({
        state: states.Loading,
        states: states,
        cart: {},
    }),
    async mounted() {
        if (!this.token) {
            this.state = states.Error;
            return;
        }

        // Get Cart Items
        let shoppingCart = await this.getCart();

        // empty / error --> "had trouble recovering your cart"
        if (!shoppingCart || !shoppingCart.data || shoppingCart.data.length === 0) {
            this.state = states.Error;
            return;
        }

        // Load products into cart
        await this.setStoreState();
        await this.loadCart(shoppingCart);
        this.state = states.Success;

        // redirect to cart page
        this.redirectToCartPage();
    },
    methods: {
        async getCart() {
            this.cart = await this.$store.dispatch("getCartForToken", this.token);
            return this.cart;
        },
        async setStoreState() {
            // Switch Homeschool Store if needed
            if (this.isHomeschoolCart && !this.isHomeschool) {
                localStorage.setItem('first_homeschool_visit', true);
                await this.$store.dispatch('setAsHomeschoolStore', true);
            }

            else if (!this.isHomeschoolCart && this.isHomeschool)
                await this.$store.dispatch('setAsHomeschoolStore', false);

            // Or just set the selected state
            else if (this.cart.state != this.selectedState)
                await this.$store.dispatch('getStateData', {state: this.cart.state});
        },
        async loadCart(shoppingCart) {
            this.$store.commit('clearCart');
            this.$store.commit('setCartId', shoppingCart.id);
            this.$store.commit('setMultiyearValue', {label: '', value: 1});
            this.$store.commit('setRecoverToken', this.token);


            for (let item of shoppingCart.data) {
                let productData = this.getFullProductData(item);
                if (!productData) {
                    console.error(`Product data for SKU ${item.sku} not found. Skipping item.`);
                    continue;
                }


                await this.$store.commit('addItem', productData);
            }
        },
        getFullProductData(product) {
            let matchingProduct = this.publications.find(p => p.sku === product.sku);
            if (!matchingProduct) {
                // We don't want users coming back after a long period of time and being able to checkout with old products.
                return null;
            }

            // Overwrite base values with saved values
            product = Object.assign(matchingProduct, product);
            product.type = 'classroom';

            if (!product.multiyear)
                product.multiyear = 1;

            if (!product.format)
                product.format = 'print_online';

            return product;
        },
        redirectToCartPage() {
            this.$router.push('/cart');
        },


    }
}
</script>

<style scoped lang="scss">

</style>